import ApiBase from '../ApiBase';

class Survey extends ApiBase {
    /**
     * @method checkSubmission
     * @param {string} survey
     * @returns {Promise<*>}
     */
    checkSubmission = () => {
        return this.get('survey/check-submission');
    };

    /**
     * @method store
     * @param {object} data
     * @returns {Promise<*>}
     */
    store = (data) => {
        return this.post('survey', data);
    };
}

export default new Survey();
